/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../api/index';
import * as core from '../../core';
import * as serializers from '../index';

export const CredentialClaimLinkedCredentialValue: core.serialization.ObjectSchema<
    serializers.CredentialClaimLinkedCredentialValue.Raw,
    Truvity.CredentialClaimLinkedCredentialValue
> = core.serialization.object({
    digestMultibase: core.serialization.property('digest_multibase', core.serialization.string().optional()),
    id: core.serialization.string(),
});

export declare namespace CredentialClaimLinkedCredentialValue {
    export interface Raw {
        digest_multibase?: string | null;
        id: string;
    }
}
